import { createGlobalStyle, keyframes } from "styled-components";

const SkeletonAnimation = keyframes`
  0% {
    background-position: -150vw 0;
  }

  40%, 100% {
    background-position: 50vw 0;
  }
`;

export const SkeletonAnimationName = SkeletonAnimation.getName();

const SkeletonGlobalStyle = createGlobalStyle`
[data-skeleton~="true"] {
    position: relative;
    overflow: hidden;
    color: transparent !important;
    background: none !important;
    border-color: ${({ theme }) => theme.background_light} !important;
    user-select: none !important;
    pointer-events: none !important;

    animation-duration: var(--skeleton-duration, 0s);
    animation-delay: var(--skeleton-delay, 0s);

    & * {
        color: transparent !important;
        pointer-events: none !important;
    }

    &:empty::before {
        content: "\feff";
        visibility: hidden;
    }

    &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        height: 100% !important;
        width: 100% !important;
        opacity: 1 !important;
        background-image: linear-gradient(
          90deg,
          var(--skeleton-background-color, ${({ theme }) => theme.background_light}) 0,
          var(--skeleton-background-color, ${({ theme }) => theme.background_light}) 30%,
          var(--skeleton-placeholder-color, ${({ theme }) => theme.background_mid}) 45%,
          var(--skeleton-placeholder-color, ${({ theme }) => theme.background_mid}) 55%,
          var(--skeleton-background-color, ${({ theme }) => theme.background_light}) 60%,
          var(--skeleton-background-color, ${({ theme }) => theme.background_light}) 100%
        ) !important;
        background-attachment: fixed;
        background-size: 200vw 100%;
        background-position: -150vw 0;
        z-index: 1;

        body[data-reduced-motion~="false"] & {
            animation: ${SkeletonAnimation} 3s 0.6s linear infinite;
        }
    }
}
`;

export default SkeletonGlobalStyle;
